/** Tactik 独立站底栏公司主体与备案信息 */
export const STANDALONE_FOOTER = {
  companyName: "上海魔法向量人工智能技术有限公司",
  icpLabel: "沪ICP备2026025499号-2",
  icpQueryUrl: "https://beian.miit.gov.cn/",
  policeLabel: "" as string,
  policeQueryUrl: "http://www.beian.gov.cn/portal/registerSystemInfo",
} as const;
